<style scoped lang="scss">
@import "@/assets/scss/global.scss";

.glaze-h1 {
    font-size: 24px;
    font-weight: 300;
    z-index: 2;
    letter-spacing: .96px;
    min-width: 323px;
    color: #022266;
    line-height: 48px;
    font-size: 32px;
}

.title-bar {
    max-width: 1032px;
    margin-left: auto;
    margin-right: auto;

    font-size: 24pt;
    font-weight: 300;
    line-height: 47px;
    z-index: 2;
    letter-spacing: 0.96px;
    min-width: 323px;
    color: $glaze-blue;

    @media (max-width: 323px) {
        min-width: 296px;
        font-size: 36px;
    }
}

.header-background {
    border-top: 1px solid #e7e7e7;
    background-color: #fafafa;
    padding-top: 42px;
    padding-bottom: 42px;
    border-bottom: 1px solid #e7e7e7;
}

.glaze-content-wrapper {
    max-width: 1032px;
    margin-left: auto;
    margin-right: auto;
}

.content-wrapper {
    line-height: 24px;
    max-width: 1032px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 32px;
    position: relative;
}

.intro-statement {
    width: 600px;
}

.price-table-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.price-table-title {
    margin-bottom: 16px;
}

table,
td,
th {
    border: 1px solid #ccc;
}

table {
    z-index: 2;
    background-color: #fff;
    border-collapse: collapse;
    width: 949px;
}

table {
    border-collapse: collapse;
    border-spacing: 0;
}

.price-table-label-header {
    width: 262px;
    max-width: 262px;
}

td,
th {
    text-align: center;
    vertical-align: middle;
}

.price-table-header {
    height: 60px;
}

.price-table-column {
    width: 135px;
    max-width: 135px;
}

.piechart-image {
    z-index: 1;
    position: absolute;
    top: -31px;
    right: -48px;
    height: 407px;
}

.price-table-price-column {
    font-weight: 600;
    width: 135px;
    max-width: 135px;
}

.price-table-row {
    height: 86px;
}

.label-cell {
    text-align: left;
    padding-left: 25px;
}

.bottom-statement {
    position: relative;
    width: 600px;
}

.separator-50 {
    height: 50px;
}

.separator-40 {
    height: 40px;
}

.separator-30 {
    height: 30px;
}

.separator-90 {
    height: 90px;
}

.link {
    color: #8946ff;
    font-weight: 500;
    font-size: 14px;
}

.link,
.link-bold {
    color: #7e34ff;
    cursor: pointer;
}

.brainstorm-image-container {
    position: absolute;
    right: -412px;
    top: -10px;
}

.brainstorm-image {
    height: 417px;
}

.illustration-info {
    cursor: pointer;
    font-size: 80%;
    padding-right: 18px;
}

.brainstorm-image-subtext {
    position: absolute;
    right: 53px;
    bottom: 9px;
}

.illustration-info .v-icon {
    font-size: 12px;
}
</style>

<template>
    <div class="about-wrapper">
        <div class="header-background">
            <v-layout class="title-bar" row>
                <v-flex class="glaze-h1">
                    Our Prices & Licenses
                </v-flex>
            </v-layout>
        </div>
        <div class="content-wrapper">
            <div class="intro-statement">
                All of our images are free to use with attribution. <br><br>
                However, if you’d like more — such as the source file, multiple colorways,
                and larger sizes, you can buy a full license. A full license supports the
                artist, allows you to use illustration an unlimited amount of times, and
                there is no need to attribute the illustrator.
            </div>
            <div class="desktop-price-chart">
                <div class="separator-40"></div>
                <div class="price-table-wrapper">
                    <div class="price-table-title">
                        OUR PRICES
                    </div>
                    <table class="price-table">
                        <tr class="price-table-header">
                            <th class="price-table-label-header"></th>
                            <th class="price-table-column">Attribution <br>
                                Required</th>
                            <th class="price-table-column">Source Files</th>
                            <th class="price-table-column">Multiple <br>Color-ways
                            </th>
                            <th class="price-table-column">Full size</th>
                            <th class="price-table-price-column">Price</th>
                        </tr>
                        <tr class="price-table-row">
                            <td class="label-cell">Free with attribution</td>
                            <td><img src="@/assets/icons/check.svg" alt=""></td>
                            <td><img src="@/assets/icons/red-cross.svg" alt="">
                            </td>
                            <td><img src="@/assets/icons/red-cross.svg" alt="">
                            </td>
                            <td><img src="@/assets/icons/red-cross.svg" alt="">
                            </td>
                            <td>FREE</td>
                        </tr>
                        <tr class="price-table-row">
                            <td class="label-cell">Standard</td>
                            <td><img src="@/assets/icons/red-cross.svg" alt="">
                            </td>
                            <td><img src="@/assets/icons/check.svg" alt=""></td>
                            <td><img src="@/assets/icons/check.svg" alt=""></td>
                            <td><img src="@/assets/icons/check.svg" alt=""></td>
                            <td>$10</td>
                        </tr>
                        <tr class="price-table-row">
                            <td class="label-cell">Premium</td>
                            <td><img src="@/assets/icons/red-cross.svg" alt="">
                            </td>
                            <td><img src="@/assets/icons/check.svg" alt=""></td>
                            <td><img src="@/assets/icons/check.svg" alt=""></td>
                            <td><img src="@/assets/icons/check.svg" alt=""></td>
                            <td>$20</td>
                        </tr>
                    </table>
                </div>
            </div>
            <img src="@/assets/illustrations/man-pie-chart.png" alt="" class="piechart-image">
            <div class="separator-30"></div>
            <div class="bottom-statement">
                <div class="separator-30"></div><span>IMAGE LICENSES</span>
                <div class="separator-20"></div>
                All illustrations in our library are a part of our Royalty-Free License. <br>
                <div class="separator-30"></div>
                The license covers commercial use including: <br><br>
                Advertising, promotion, communication, and editorial use, books and book covers including
                electronic books, newspapers, direct mail, consumer magazines, trade magazines, television
                commercials, annual reports, brochures, newsletters, invitations, Internet banners, website
                graphics, software graphics, marketing campaigns, sales kits, promotional items, corporate
                presentations. <br><br>
                Unlimited printed impressions/editorial in magazines and newspapers. <br><br><br>
                <span class="link" @click="$router.push(`/license`)"> See
                    the full image
                    licensing agreement </span>
                <div class="brainstorm-image-container"><img src="@/assets/illustrations/team-brainstorm-floor.png"
                        alt="" class="brainstorm-image">
                    <div class="illustration-info brainstorm-image-subtext">
                        Illustrated by Shaji Mon<br>source: Glaze
                        <i aria-hidden="true" class="v-icon material-icons theme--light">open_in_new</i>
                    </div>
                </div>
            </div>
            <div class="separator-90"></div>
        </div>
    </div>


</template>

<script>
export default {
    mounted: function () {
    },
    data() {
        return {};
    }
    // methods: {},
    // watch: {},
    // computed: {},
    // created() {},
    // components: {}
};
</script>
